<template>
  <div class="container-main">
    <bannerVideo bg="#949590" videoUrl="https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/videos/weclassroom.mp4" allVideoUrl="https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/videos/weclassroom-all.mp4" title="直播云" message="专注打造多场景直播服务平台"></bannerVideo>
    <outboxCon bg="#F8F9FD">
        <div class="my-production">
          <header>OMO一站式解决方案</header>
          <p>以在线授课为中心、构建线上线下融合的一站式解决方案</p>
          <div class="content">
            <img :src="omo" alt="">
          </div>
        </div>
    </outboxCon>
    
    <outboxCon bg="#fff">
        <div class="my-content">
          <header>多场景全平台线上教学</header>
          <ul>
            <li v-for="item in myContentList" :key="item.title">
              <img :src="item.image" alt="" />
              <h6>{{ item.title }}</h6>
              <span>{{ item.content }}</span>
            </li>
            <!--手动添加两个空dom 用来匹配flex样式-->
            <li></li>
            <li></li>
          </ul>
        </div>
    </outboxCon>

    <outboxCon bg="#F8F9FD">
        <div class="choice-me">
          <header>直播云服务的客户</header>
          <div class="content">
            <img :src="customerImg" alt="">
          </div>
        </div>
    </outboxCon>

    <outboxCon bg="#fff">
        <div class="product-characteristic">
          <header>直播云产品特色</header>
          <div class="content">
            <div class="left">
              <img :src="characteristicImg" alt="">
            </div>
            <ul class="right">
              <li v-for="item in characteristicList" :key="item.title">
                <div>
                  <img :src="item.image" alt="">
                </div>
                <div class="right-content">
                  <p>{{ item.title }}</p>
                  <p>{{ item.content }}</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
    </outboxCon>
  </div>
</template>
<script>
import bannerVideo from './components/bannerVideo/bannerVideo'
export default {
  data () {
    return {
      omo: require('@/assets/coursetype/zhiboyun/omo.png'),
      customerImg: require('@/assets/coursetype/zhiboyun/customer-data.png'),
      characteristicImg: require('@/assets/coursetype/zhiboyun/tese.png'),
      myContentList: [
        {
          image: require('@/assets/coursetype/zhiboyun/scene-1.png'),
          title: '互动小班',
          content: '真实还原线下教学场景'
        },
        {
          image: require('@/assets/coursetype/zhiboyun/scene-2.png'),
          title: '万人大班',
          content: '多种互动方式，万人在线，实时留言，畅快沟通'
        },
        {
          image: require('@/assets/coursetype/zhiboyun/scene-3.png'),
          title: '1V1量身定制',
          content: '量身定制，个性辅导，让教学更有针对性'
        },
        {
          image: require('@/assets/coursetype/zhiboyun/scene-3.png'),
          title: '全平台支持',
          content: '支持win、mac、ios、安卓、网页、微信小程序等终端'
        }
      ],
      characteristicList: [
        {
          image: require('@/assets/coursetype/zhiboyun/tese-1.png'),
          title: '稳定易用上手快',
          content: '万人同时直播，流畅沟通不卡顿；海外加速遍布全球，超200节点；操作简单，无需培训'
        },
        {
          image: require('@/assets/coursetype/zhiboyun/tese-2.png'),
          title: '构建真实教学场景',
          content: '班级场：还原线下卡糖氛围；强互动：丰富的互动和激励；强控场：关注每一个学生'
        },
        {
          image: require('@/assets/coursetype/zhiboyun/tese-3.png'),
          title: '在线教学更专业',
          content: '全面支持交互式课件；课中练习，边讲边练；与海量教学资源打通，学科工具随时用'
        },
        {
          image: require('@/assets/coursetype/zhiboyun/tese-4.png'),
          title: '学习行为数据化',
          content: '练习巩固线上发布、灵活作答、自动批改；学情报告，效果可视化'
        }
      ]
    }
  },
  components: { bannerVideo }
}
</script>

<style lang="scss" scoped>
.my-production,
.choice-me,
.my-content,
.product-characteristic {
  width: $main-width;
  margin: 0 auto;
  padding: 68px 0px 84px 0px;
  position: relative;
  header {
    height: 56px;
    font-size: 40px;
    font-weight: 500;
    color: #282828;
    line-height: 56px;
  }
  .content {
    img {
      width: 1280px;
    }
  }
  p {
    padding-bottom: 43px;
    height: 22px;
    font-size: 16px;
    font-weight: 400;
    color: #282828;
  }
}

.my-content {
  padding-bottom: 172px;
  ul {
    padding-top: 44px;
    padding-inline-start: 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    li {
      position: relative;
      width: 614px;
      img {
        width: 614px;
      }
      h6 {
        position: absolute;
        bottom: 36px;
        left: 0;
        width: 100%;
        font-size: 24px;
        font-weight: 600;
        color: #5280FB;
      }
      span {
        display: inline-block;
        vertical-align: top;
        font-size: 18px;
        font-weight: 400;
        color: #8E9DAE;
        line-height: 28px;
      }
    }
  }
}

.choice-me {
  position: relative;
  padding: 0;
  header {
    position: absolute;
    top: 74px;
    width: 100%;
  }
}

.product-characteristic {
  .content {
    display: flex;
    flex-direction: row;
    padding-top: 97px;
    .left {
      margin-left: 74px;
      width: 637px;
      img {
        width: 637px;
        height: 395px;
      }
    }
    .right {
      padding-left: 88px;
      img {
        width: 54px;
        height: 54px;
      }
      li {
        display: flex;
        flex-direction: row;
        padding-bottom: 40px;
        .right-content {
          padding-left: 24px;
          width: 360px;
          text-align: left;
          p {
            padding-bottom: 0;
          }
          p:nth-of-type(1) {
            font-size: 24px;
            font-weight: 500;
            color: #202428;
            line-height: 30px;
          }
          p:nth-of-type(2) {
            padding-top: 12px;
            font-size: 16px;
            font-weight: 400;
            color: #62687B;
            line-height: 24px;
          }
        }
      }
    }
  }
}
</style>
